






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentPartsBlogAside extends Vue {
  @Prop({ type: String, default: 'Читайте также' })
  titleText: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/blog/aside/Aside.vue